import { render, staticRenderFns } from "./VCollapseItem.vue?vue&type=template&id=73599eff&scoped=true&"
import script from "./VCollapseItem.vue?vue&type=script&lang=js&"
export * from "./VCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./VCollapseItem.vue?vue&type=style&index=0&id=73599eff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73599eff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73599eff')) {
      api.createRecord('73599eff', component.options)
    } else {
      api.reload('73599eff', component.options)
    }
    module.hot.accept("./VCollapseItem.vue?vue&type=template&id=73599eff&scoped=true&", function () {
      api.rerender('73599eff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/collapse/VCollapseItem.vue"
export default component.exports